import {Component, Vue} from 'vue-property-decorator';

import {availableLocales} from '@/translations';

@Component({})
export default class TranslatedRouter extends Vue {
	availableLocales: string[] = availableLocales;

	get locale(): string {
		return this.$store.state.locale;
	}

	async changeLocale(locale: string): Promise<void> {
		if (locale === this.locale || locale === this.$i18n.locale) {
			await this.$router.replace({
				name: `${this.$route.name!.split('-')[0]}-${locale}`,
				query: {modal: undefined}
			});
			this.$forceUpdate();
			return;
		}

		const to = this.$router.resolve({
			name: `${this.$route.name!.split('-')[0]}-${locale}`
		});

		await this.$router.push(to.location);

		this.$i18n.locale = locale;

		await this.$store.dispatch('updateLocale', locale);
		this.$router.go(0);
	}

	path(name: string | null = null, locale: string = this.locale, params: { [key: string]: string } | null = null): string {
		const to = this.$router.resolve({
			name: name ? `${name}-${locale}` : `${this.$route.name!.split('-')[0]}-${locale}`,
			params: params ? params : {}
		});

		return to.route.fullPath;
	}
}
